import { onBeforeUpdate, ref } from 'vue'

export const useRefs = () => {
  const refs = ref([])

  const setRefs = (el) => {
    if (!el) return
    refs.value.push(el)
  }

  onBeforeUpdate(() => {
    refs.value = []
  })

  return [refs, setRefs]
}
